export const fileUriToURl = (uri)=>{
	    if(uri.match(/^public:\/\//)){

                //return 'https://cdn.evenses.com/'+encodeURIComponent(uri.slice(9))
                return 'https://storage.googleapis.com/evenses/'+uri.slice(9)
            }
            return false
}

export const wbrConvert=s=>typeof s==='string'?s.replace(/<wbr>/gi,"\u00AD"):s